/* jshint -W098 */

/*EXTJS6: warnings aria désactivés*/
Ext.ariaWarn = Ext.emptyFn;

if (typeof ExtFwk === 'undefined') {
  // Alias for ExtPascal
  ExtFwk = Ext;
  /*jshint ignore:line*/
}
/* jshint ignore:start */


if (!String.prototype.repeat) {
  // String.repeat is not supported in IE, so we define it
  String.prototype.repeat = function (count) {
    "use strict";

    if (this == null) throw new TypeError("ne peut convertir " + this + " en objet");
    var str = "" + this;
    count = +count;
    if (count != count) count = 0;
    if (count < 0) throw new RangeError("le nombre de répétitions doit être positif");
    if (count == Infinity) throw new RangeError("le nombre de répétitions doit être inférieur à l'infini");
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return ""; // En vérifiant que la longueur résultant est un entier sur 31-bit
    // cela permet d'optimiser l'opération.
    // La plupart des navigateurs (août 2014) ne peuvent gérer des
    // chaînes de 1 << 28 caractères ou plus. Ainsi :

    if (str.length * count >= 1 << 28) throw new RangeError("le nombre de répétitions ne doit pas dépasser la taille de chaîne maximale");
    var rpt = "";

    for (;;) {
      if ((count & 1) == 1) rpt += str;
      count >>>= 1;
      if (count == 0) break;
      str += str;
    }

    return rpt;
  };
} // https://tc39.github.io/ecma262/#sec-array.prototype.find


if (!Array.prototype.find) {
  // Array.find is not supported in IE, so we define it
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this); // 2. Let len be ? ToLength(? Get(O, "length")).

      var len = o.length >>> 0; // 3. If IsCallable(predicate) is false, throw a TypeError exception.

      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      } // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.


      var thisArg = arguments[1]; // 5. Let k be 0.

      var k = 0; // 6. Repeat, while k < len

      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];

        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        } // e. Increase k by 1.


        k++;
      } // 7. Return undefined.


      return undefined;
    }
  });
}
/* jshint ignore:end */


Ext.onReady(function () {
  Ext.getDoc().on('keypress', function (e) {
    // Prevent websocket from disconnecting in Firefox when pressing escape key
    if (e.getKey() == e.ESC && !e.ctrlKey && !e.altKey && !e.shiftKey) {
      e.preventDefault();
      return false;
    }
  });
});

function documentUrlBase() {
  return window.location.origin || window.location.protocol + '//' + window.location.host; //        -> for Chrome                -> for Firefox & IE
}

function documentUrlPath() {
  return window.location.pathname;
} // Get Url root context


function documentUrlContext() {
  var documentUrl = documentUrlPath(),
      arrayUrl = documentUrl.match('/([^/]+)');
  if (arrayUrl) return arrayUrl[1];
  return '';
}

function documentHeight() {
  return document.height || document.body.clientHeight || document.documentElement.clientHeight; //       -> for Chrome      -> for Firefox & IE           -> for Firefox & Chrome
}

function documentWidth() {
  return document.width || document.body.clientWidth || document.documentElement.clientWidth; //       -> for Chrome      -> for Firefox & IE           -> for Firefox & Chrome
}

function clearListeners(elt, eventName) {
  eventName = eventName.toLowerCase();
  if (elt.events[eventName]) elt.events[eventName].listeners = [];
}

function removeListeners(elt, eventName, fnName) {
  var evtName = eventName.toLowerCase(),
      listeners = elt.events && elt.events[evtName];
  if (!listeners || typeof listeners == "boolean") return;

  if (listeners.listeners) {
    listeners = listeners.listeners;
  }

  if (listeners) {
    for (var len = listeners.length, i = len - 1; i >= 0; --i) {
      if (listeners[i].fn.name == fnName) {
        listeners.splice(i, 1);
      }
    } // Mise à jour du compteur pour que hasListener() fonctionne correctement


    elt.hasListeners[evtName] = listeners.length;
  }
}

function hasExternalListener(elt, eventName, fn) {
  var listeners = elt.events[eventName.toLowerCase()];
  if (!listeners && !listeners.listeners) return;
  listeners = listeners.listeners;

  for (var len = listeners.length, i = len - 1; i >= 0; --i) {
    if (listeners[i].fn !== fn) {
      return true;
    }
  }
} // Add the object console if doesn't exist


(function () {
  if (!("console" in window)) {
    window.console = {
      log: function log() {// Do Nothing
      }
    };
  }
})();

function updateCharCase(elt, evt, upper) {
  var val = elt.value;
  evt = evt || window.event; // Ensure we only handle printable keys, excluding enter and space
  // Doit être associé à KeyPress pour avoir charCode correct. (keyDown on a uniquement keyCode et pavé numérique ne fct pas)

  var charCode = typeof evt.which == "number" ? evt.which : evt.charCode;

  if (charCode && charCode > 32 && ( // Tenir compte du maxLength (if any)
  Ext.isEmpty(elt.maxLength) || val.length < elt.maxLength)) {
    var keyChar = String.fromCharCode(charCode); // Transform typed character

    var mappedChar = keyChar;

    if (upper) {
      mappedChar = mappedChar.toUpperCase();
    } else {
      mappedChar = mappedChar.toLowerCase();
    }

    var start, end;

    if (typeof elt.selectionStart == "number" && typeof elt.selectionEnd == "number") {
      // Non-IE browsers and IE 9
      start = elt.selectionStart;
      end = elt.selectionEnd;
      elt.value = val.slice(0, start) + mappedChar + val.slice(end); // Move the caret

      elt.selectionStart = elt.selectionEnd = start + 1;
    } else if (document.selection && document.selection.createRange) {
      // For IE up to version 8
      var selectionRange = document.selection.createRange();
      var textInputRange = elt.createTextRange();
      var precedingRange = elt.createTextRange();
      var bookmark = selectionRange.getBookmark();
      textInputRange.moveToBookmark(bookmark);
      precedingRange.setEndPoint("EndToStart", textInputRange);
      start = precedingRange.text.length;
      end = start + selectionRange.text.length;
      elt.value = val.slice(0, start) + mappedChar + val.slice(end);
      start++; // Move the caret

      textInputRange = elt.createTextRange();
      textInputRange.collapse(true);
      textInputRange.move("character", start - (elt.value.slice(0, start).split("\r\n").length - 1));
      textInputRange.select();
    }

    if (evt.stopPropagation) evt.stopPropagation();
    if (evt.preventDefault) evt.preventDefault(); // Firefox

    evt.cancelBubble = true; // IE?

    evt.returnValue = false; // Chrome

    return false;
  }
} // Wrapper to send a message to server


function sendMsg(msg) {
  return Ext.ux.wx.WebSocketSingleton.send(msg);
} // Wrapper to connect a WebSocket


function connectWebSocket(port, host) {
  if (!Ext.ux.wx.WebSocketSingleton.connect(port, host)) {
    Ext.Msg.show({
      title: 'WebSocket Error',
      msg: 'Browser doesn\'t support websockets!',
      icon: Ext.Msg.ERROR,
      buttons: Ext.Msg.OK
    });
  }
}

function closeWindow() {
  // Close the ws, the window.close() may not work and if the ws is still opened when
  //  server close it, the WebSocketSingleton try to reconnect it automatically and after
  //  a few retry ask the user if he want to launch a new object.
  Ext.ux.wx.WebSocketSingleton.wsShowMsgOnClose = false;
  Ext.ux.wx.WebSocketSingleton.close(); //netscape.security.PrivilegeManager.enablePrivilege("UniversalBrowserWrite");

  window.open('', '_self');
  window.close(); // Affichage d'un splash au lieu d'un simple lien.

  Ext.create('Ext.ux.wx.SplashBackToForm', {}).show();
  /*var div = Ext.DomHelper.append("body", {tag: "div", cls: "x-login-reload"});
    Ext.DomHelper.append(div, {tag: "a", cls: "x-login-reload-text", href: "#",
                             onclick: "location.reload(true); return false;",
                             html: Ext.ux.wx.TranslateManager.getWord("Back to application")
                             });
  */
}

function openWindow(url, name, options, delay) {
  if (!delay) {
    window.open(url, name, options);
  } else {
    setTimeout(() => {
      window.open(url, name, options);
    }, delay);
  }
}

function openInCurrentWindow(url, name, options) {
  window.location.replace(url);
}
/* Inutilisé pour l'instant puisque cela ne fonctionne que dans le contexte d'un clic souris et pour ouvrir un seul
   onglet (et que cela ne foncionne pas sous IE).
function openHrefWindow(url, name, options) {
    var tmpLink = document.createElement("a");
    tmpLink.href = url;
    tmpLink.target = '_blank';
    simulatedClick(tmpLink);
}

function simulatedClick(target, options) {

    var event = target.ownerDocument.createEvent('MouseEvents'),
        options = options || {};

    //Set your default options to the right of ||
    var opts = {
        type: options.type                  || 'click',
        canBubble:options.canBubble             || true,
        cancelable:options.cancelable           || true,
        view:options.view                       || target.ownerDocument.defaultView,
        detail:options.detail                   || 1,
        screenX:options.screenX                 || 0, //The coordinates within the entire page
        screenY:options.screenY                 || 0,
        clientX:options.clientX                 || 0, //The coordinates within the viewport
        clientY:options.clientY                 || 0,
        ctrlKey:options.ctrlKey                 || false,
        altKey:options.altKey                   || false,
        shiftKey:options.shiftKey               || false,
        metaKey:options.metaKey                 || false, //I *think* 'meta' is 'Cmd/Apple' on Mac, and 'Windows key' on Win. Not sure, though!
        button:options.button                   || 0, //0 = left, 1 = middle, 2 = right
        relatedTarget:options.relatedTarget     || null
    };

    //Pass in the options
    event.initMouseEvent(
        opts.type,
        opts.canBubble,
        opts.cancelable,
        opts.view,
        opts.detail,
        opts.screenX,
        opts.screenY,
        opts.clientX,
        opts.clientY,
        opts.ctrlKey,
        opts.altKey,
        opts.shiftKey,
        opts.metaKey,
        opts.button,
        opts.relatedTarget
    );

    //Fire the event
    target.dispatchEvent(event);
}
*/


var favicon = {
  change: function change(iconURL, optionalDocTitle) {
    if (optionalDocTitle) {
      document.title = optionalDocTitle;
    }

    this.addLink(iconURL, "icon");
    this.addLink(iconURL, "shortcut icon"); // Google Chrome HACK - whenever an IFrame changes location
    // (even to about:blank), it updates the favicon for some reason
    // It doesn't work on Safari at all though :-(

    if (!favicon.IE) {
      // Disable the IE "click" sound
      if (!window.__IFrame) {
        window.__IFrame = document.createElement('iframe');
        var s = window.__IFrame.style;
        s.height = s.width = s.left = s.top = s.border = 0;
        s.position = 'absolute';
        s.visibility = 'hidden';
        document.body.appendChild(window.__IFrame);
      }

      window.__IFrame.src = 'about:blank';
    }
  },
  addLink: function addLink(iconURL, relValue) {
    var link = document.createElement("link");
    link.type = "image/x-icon";
    link.rel = relValue;
    link.href = iconURL;
    this.removeLinkIfExists(relValue);
    this.docHead.appendChild(link);
  },
  removeLinkIfExists: function removeLinkIfExists(relValue) {
    var links = this.docHead.getElementsByTagName("link");

    for (var i = 0; i < links.length; i++) {
      var link = links[i];

      if (link.type == "image/x-icon" && link.rel == relValue) {
        this.docHead.removeChild(link);
        return;
      }
    }
  },
  // Assuming only one match at most.
  docHead: document.getElementsByTagName("head")[0]
};
favicon.IE = navigator.userAgent.indexOf("MSIE") != -1;
var skinController = {
  // jshint ignore:line
  skin: null,
  select: async function select(skinName) {
    // Le skin doit être sélectionné avant l'affichage des formes (changement dynamique imparfait, problèmes de dimensions et d'alignement)
    var me = skinController,
        i,
        links,
        theme,
        script,
        skinCss = Ext.query('link[rel*="stylesheet"][href*="theme-"][title="' + skinName + '"]', document.head),
        skinFound = skinCss && skinCss.length ? true : false;

    if (!skinFound) {
      skinCss = Ext.query('link[rel*="stylesheet"][href*="ext-all"][title="' + skinName + '"]', document.head);
      skinFound = skinCss && skinCss.length ? true : false;
    }

    if (!skinFound) {
      // Si skin est null, on le détecte au passage
      if (!me.skin) {
        // Selecteur rel sans * pour ne pas tenir compte des "alternate"
        links = Ext.query('link[rel="stylesheet"][href*="theme-"]:not([disabled])', document.head);

        if (links.length == 0) {
          links = Ext.query('link[rel="stylesheet"][href*="ext-all"]:not([disabled])', document.head);
        }

        if (links.length == 1) {
          return await me.select(links[0].title);
        }
      } // Les skin demandé n'existe pas dans le dom donc on ne fait rien (pas de chargement dynamique pour l'instant)


      return false;
    }

    const newLinks = []; // Désactivation de tous les css de skin sauf celui du skin sélectionné (basé sur title).

    for (i = 0, links = Ext.query('link[rel*="stylesheet"][title]', document.head); i < links.length; i++) {
      if (links[i].title == skinName) {
        if (links[i].disabled) // links[i].disabled = false;
          newLinks.push(links[i]); // must load
      } else if (!links[i].disabled) links[i].disabled = true;
    } // Activation asynchrone des CSS


    if (newLinks && newLinks.length) try {
      const result = await me.asyncActivateCSS(newLinks);
    } catch (err) {
      throw 'Failed to load skin ' + skinName;
    } // When CSS is loading, Browser add it to styleSheets
    // [...document.styleSheets].find(x=> x.href === links[10].href)
    // // Désactivation de tous les css de skin extjs sauf celui du skin sélectionné.
    // for (i = 0, links = Ext.query('link[rel*="stylesheet"][href*="theme-"]', document.head); i < links.length; i++ ) {
    //     links[i].disabled = true;
    //     if (links[i].title == skinName) {
    //         links[i].disabled = false;
    //     }
    // }
    // for (i = 0, links = Ext.query('link[rel*="stylesheet"][href*="ext-all"]', document.head); i < links.length; i++ ) {
    //     links[i].disabled = true;
    //     if (links[i].title == skinName) {
    //         links[i].disabled = false;
    //     }
    // }
    // // Désactivation de tous les css de skin wx sauf celui du skin sélectionné. Attention à wx-all-common.css (test sur title)
    // for (i = 0, links = Ext.query('link[rel*="stylesheet"][href*="wx-all"][title]', document.head); i < links.length; i++ ) {
    //     links[i].disabled = true;
    //     if (links[i].title == skinName) {
    //         links[i].disabled = false;
    //     }
    // }
    // Chargement dynamique du script js lié au skin (pas de déchargement de l'éventuel ancien car on ne peut de
    // toute façon pas annuler son exécution).

    if (skinName.startsWith('Solva') || skinName.startsWith('Silver')) {
      theme = skinName;
    } else {
      theme = skinName.toLowerCase();

      if (theme === 'blue') {
        theme = 'classic';
      }
    }
    /*
    script = window.document.createElement('script');
    script.type = 'text/javascript';
    script.src = '/erp/ext' + '/classic/theme-' + theme + '/theme-' + theme + '-debug.js';
    window.document.head.appendChild(script);
    */


    const skinScript = {
      href: '/erp/ext'.concat("/classic/theme-", theme, "/theme-").concat(theme, ".js"),
      tag: 'script',
      parent: 'body'
    };

    try {
      const result = await Ext.ux.wx.ApplicationManager.asyncLoad([skinScript]);
    } catch (err) {
      console.error("Failed to load script for skin ".concat(skinName)); // throw 'Failed to load script for skin '+skinName;
    }

    me.skin = skinName;
    return true;
  },
  asyncActivateCSS: function asyncActivateCSS(links) {
    return Promise.all(links.map(link => new Promise((resolve, reject) => {
      // success or error for the promise
      link.onload = () => {
        resolve(link);
      };

      link.onerror = () => {
        reject(link);
      };

      link.disabled = false;
    })));
  },
  selectFont: function selectFont(name, size) {
    var me = skinController,
        genericName,
        safeName,
        style = document.createElement('style'); // zoom;

    me.fontName = name;
    me.fontSize = size;
    /* Flexmonster ne supporte pas l'export vers Excel si la police contient un espace (le navigateur rajoute
       systématiquement des "" même si on ne les mets pas et le style.xml du xlsx se retrouve avec une balise
       invalide : <name val=""Segoe UI""/>)
    */

    if (name === 'Segoe UI') {
      safeName = 'sans-serif';
      genericName = 'sans-serif';
    } else if (name === 'Times New Roman') {
      safeName = 'serif';
      genericName = 'serif';
    } else if (name.includes(' ')) {
      safeName = 'sans-serif';
      genericName = 'sans-serif';
    } else {
      safeName = name + ', sans-serif';
      genericName = 'sans-serif';
    }

    document.body.style.fontFamily = '"' + name + '", ' + genericName;
    document.body.style.fontSize = size + 'pt';
    /* Zoom à définir au niveau du body par css après correction du positionnement des PopupMenus
    if (name.toUpperCase() == "SEGOE UI") {
        zoom = Math.round(size/9*100);
    } else {
        zoom = Math.round(size/8*100);
    }
    */

    style.setAttribute('type', 'text/css');
    /*EXTJS6: liste à contrôler*/

    style.innerHTML = //'.x-body {zoom:' + zoom + '%;} ' +
    '.x-panel-body-default, ' + // Appliqué aux composants par héritage
    '.x-form-cb-label, .x-form-item, .x-form-field, ' + // Libellé de case à cocher et contenu d'edit
    '.x-tab-default .x-tab-inner, ' + // Titre d'onglet
    '.x-panel-header-title-default, ' + //'.x-panel-header-text-container-default, ' + // Titre de panel
    '.x-column-header, .x-grid-cell, .x-grid-empty, ' + // Entête et cellule de grid
    '.x-grid-editor .x-form-text, ' + // Editeur de cellule
    '.x-grid-row-summary .x-grid-cell, .x-grid-row-summary .x-grid-rowwrap, .x-grid-row-summary .x-grid-cell-rowbody, ' + // Totaux groupes
    '.x-dataview-item, .x-list-input,  ' + // Textes des listes
    '.x-btn-default-toolbar-small .x-btn-inner, .x-btn-default-toolbar-medium .x-btn-inner, ' + // Boutons du ribbon
    '.x-btn-group-header-title-default-framed, ' + // Groupes du ribbon
    '.x-btn-default-small .x-btn-inner, ' + // Boutons
    '.x-talk-btn, ' + // Boutons du Talk
    '.x-menu-item-text-default, ' + // Menu items
    '.x-toolbar-text, ' + // Barre d'état
    '.x-window-header-title-default, .x-window-body-default, ' + //'.x-window-header-text-container-default, ' + // Titre et contenu de fenêtre
    '.x-btn-group-header-text-container-default-framed, ' + // Titre de groupe du ribbon
    '.x-mask-msg-inner, ' + // Veuillez patienter
    '.x-form-display-field ' + // Texte ErrorBox
    '{font-family: "' + name + '", ' + genericName + ';}' + // Flexmonster (flexmonster/theme/old/flexmonster.min.css):
    '#fm-pivot-view .fm-ui,#fm-pivot-view .fm-ui a,#fm-pivot-view .fm-ui div,#fm-pivot-view .fm-ui input,#fm-pivot-view .fm-ui li,#fm-pivot-view .fm-ui p,#fm-pivot-view .fm-ui select,#fm-pivot-view .fm-ui span,#fm-pivot-view .fm-ui table,#fm-pivot-view .fm-ui table td,#fm-pivot-view .fm-ui table th,#fm-pivot-view .fm-ui table tr,#fm-pivot-view .fm-ui textarea,#fm-pivot-view .fm-ui ul,#fm-toolbar-wrapper .fm-toolbar-ui,#fm-toolbar-wrapper .fm-toolbar-ui a,#fm-toolbar-wrapper .fm-toolbar-ui div,#fm-toolbar-wrapper .fm-toolbar-ui input,#fm-toolbar-wrapper .fm-toolbar-ui li,#fm-toolbar-wrapper .fm-toolbar-ui p,#fm-toolbar-wrapper .fm-toolbar-ui select,#fm-toolbar-wrapper .fm-toolbar-ui span,#fm-toolbar-wrapper .fm-toolbar-ui table,#fm-toolbar-wrapper .fm-toolbar-ui table td,#fm-toolbar-wrapper .fm-toolbar-ui table th,#fm-toolbar-wrapper .fm-toolbar-ui table tr,#fm-toolbar-wrapper .fm-toolbar-ui textarea,#fm-toolbar-wrapper .fm-toolbar-ui ul' + '{font-family: ' + safeName + ' !important;}';
    document.head.appendChild(style);
  }
};
Ext.ux.wx.ApplicationManager.initValues();